var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('client-only',[_c('to-top',{staticClass:"totop"})],1),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }